// extracted by mini-css-extract-plugin
export default {"toolHeading":"ToolHeading_toolHeading__3HuQ7"};